import React from 'react';
import { Link } from 'react-router-dom';

const URL_PATTERN_DOMAIN = /^(https?:\/\/)?[^\s/$.?#][^\s]*/i;

function normalizeUrl(url) {
    if (/^https?:\/\//i.test(url)) return url;
    return `https://${url}`;
}

class QuickLinkForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            title: props.quickLink ? props.quickLink.title : '',
            url: props.quickLink ? props.quickLink.url : '',
            errors: {}
        };
    }

    validate() {
        const errors = {};
        if (!this.state.title.trim()) {
            errors.title = 'Title is required.';
        }
        const url = this.state.url.trim();
        if (!url) {
            errors.url = 'URL is required.';
        } else if (!URL_PATTERN_DOMAIN.test(url)) {
            errors.url = 'URL must include a valid domain (e.g. example.com or https://example.com)';
        }
        return errors;
    }

    onFormSubmit(event) {
        event.preventDefault();

        const errors = this.validate();
        if (Object.keys(errors).length > 0) {
            this.setState({ errors });
            return;
        }

        this.props.onSubmit({
            title: this.state.title.trim(),
            url: normalizeUrl(this.state.url.trim())
        });
    }

    render() {
        const { title, url, errors } = this.state;
        const deleteButton = this.props.onDelete !== undefined
            ? <li className="pull-right"><a className="btn btn-danger" onClick={this.props.onDelete}>Delete</a></li>
            : '';

        return (
            <div className="login-form">
                <div className={`form-group${errors.title ? ' has-error' : ''}`}>
                    <label>Title</label>
                    <div>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Title"
                            value={title}
                            onChange={e => this.setState({ title: e.target.value, errors: { ...errors, title: null } })}
                        />
                        {errors.title && <span className="input-error">{errors.title}</span>}
                    </div>
                </div>
                <div className={`form-group${errors.url ? ' has-error' : ''}`}>
                    <label>URL</label>
                    <div>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="example.com or https://example.com"
                            value={url}
                            onChange={e => this.setState({ url: e.target.value, errors: { ...errors, url: null } })}
                        />
                        {errors.url && <span className="input-error">{errors.url}</span>}
                    </div>
                </div>
                <hr />
                <ul className="list-inline clearfix">
                    <li>
                        <button type="submit" onClick={this.onFormSubmit.bind(this)} className="btn btn-primary">
                            {this.props.quickLink ? 'Update' : 'Save'}
                        </button>
                    </li>
                    <li>
                        <Link to="/admin-admin/quick-links">
                            <button className="btn btn-default">Cancel</button>
                        </Link>
                    </li>
                    {deleteButton}
                </ul>
            </div>
        );
    }
}

export default QuickLinkForm;
